import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enUS from './en-US.json';
import frFR from './fr-FR.json';

const enSchema = enUS;  // You can separate if you want
const frSchema = frFR;

// Supported languages
const supportedLanguages = ['en-US', 'fr-FR'];

// Initialize i18n instance
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'en-US': {
        translation: enUS,  // default namespace
        schema: enSchema,   // named namespace "schema"
      },
      'en': {
        translation: enUS,  // Alias for en-US
        schema: enSchema,
      },
      'fr-FR': {
        translation: frFR,
        schema: frSchema,
      },
      'fr': {
        translation: frFR,  // Alias for fr-FR
        schema: frSchema,
      }
    },
    ns: ['translation', 'schema'],
    defaultNS: 'translation',
    supportedLngs: ['en-US', 'en', 'fr-FR', 'fr'],
    fallbackLng: {
      'fr': ['fr-FR', 'en-US', 'en'],
      'fr-FR': ['en-US', 'en'],
      'en': ['en-US'],
      'en-US': ['en'],
      default: ['en-US', 'en'],
    },
    interpolation: { escapeValue: false },
    debug: true,
    detection: {
      // Order of language detection:
      // 1. Will be overridden by user preference in PreferencesOrganism
      // 2. Browser language
      // 3. Fallback to en-US
      order: ['navigator'],
      caches: [],
    },
  });

export default i18n;
